import styled from 'styled-components'
import Text from '../atoms/Text'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';

const Container = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.neutral[100]};
  padding: 12px 16px;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`
const ArrowIcon = styled(ArrowForwardIosRoundedIcon)`
  color: ${(props) => props.theme.colors.text.assistive};
`

const TutorialCard = ({ title, description, onClick }) => {
  return (
    <Container onClick={onClick}>
      <TextWrapper>
        <Text weight="medium">{title}</Text>
        <Text variant="caption" color="assistive">{description}</Text>
      </TextWrapper>
      <ArrowIcon sx={{ fontSize: 16 }}/>
    </Container>
  )
}

export default TutorialCard
